import AxiosInterceptor from "../utils/AxiosInterceptor";
import { API_BASE } from '../utils/constants';

export const apiAuth = {
    resetPassword:   (value) => AxiosInterceptor().post(API_BASE + "/auth/update-password", value),
    getAdminDetails: (value) => AxiosInterceptor().get(API_BASE + "/auth/getAdminDetails", value),
    updateAdminProfile: (value) => AxiosInterceptor().post(API_BASE + "/auth/editProfile", value),
    changePassword : (value) => AxiosInterceptor().post(API_BASE + "/auth/changePassword", value),
    getSetting: (value) => AxiosInterceptor().get(API_BASE + "/auth/getSetting", value),  
    updateSetting : (value) => AxiosInterceptor().post(API_BASE + "/auth/updateSetting", value),
};

export const userServices = {
    getUser: (values) => AxiosInterceptor().post(`/user/getAllUsers`, values),
    getById: (values) => AxiosInterceptor().get(`/user/getOneUser/${values?.id}`),
    add: (values) => AxiosInterceptor().post(`/user/addUser`, values),
    edit: (value) => AxiosInterceptor().post(`/user/updateUser`, value),
    deleteUser: (value) => AxiosInterceptor().post(`/user/deleteUser`, value),
    changeStatus: (value) => AxiosInterceptor().post(`/user/changeStatus`, value),
};

export const modelServices = {
    getmodel: (values) => AxiosInterceptor().post(`/model/getallModel`, values),
    getById: (values) => AxiosInterceptor().get(`/model/getonemodel/${values?.id}`),
    add: (values) => AxiosInterceptor().post(`/model/addmodel`, values),
    edit: (value) => AxiosInterceptor().post(`/model/modelupdate`, value),
    deleteModel: (value) => AxiosInterceptor().post(`/model/deletemodel`, value),
    changeStatus: (value) => AxiosInterceptor().post(`/model/chnageStatus`, value),
    modelverify: (values) => AxiosInterceptor().post(`/model/modelverify`, values),
    comissionUpdate: (value) => AxiosInterceptor().post(`/model/comissionUpdate`, value),
    getAllDetails: (values) => AxiosInterceptor().get(`/model/getmodelDetails/${values?.id}`),
};

export const bitPackageServices = {
    add: (values) => AxiosInterceptor().post(`/bidPackage/bid-package`, values),
    getBids: (values) => AxiosInterceptor().post(`/bidPackage/get-bid-package`, values),
    getById: (values) => AxiosInterceptor().post(`/bidPackage/get-single-bid-package`, values),
    edit: (value) => AxiosInterceptor().post(`/bidPackage/update-bid-package`, value),
    deleteBid: (value) => AxiosInterceptor().post(`/bidPackage/delete-bid-package`, value),
    changeStatus: (value) => AxiosInterceptor().post(`/bidPackage/update-status`, value),
};

export const emailServices = {
    // Email
    getEmail: (values) => AxiosInterceptor().post(`/emailTemplate/getAllTemplate`, values),
    addEmail: (value) => AxiosInterceptor().post(`/emailTemplate/addTemplate`, value),
    getByIdEmail: (values) => AxiosInterceptor().get(`/emailTemplate/getOneTemplate/${values.id}`, ),
    editEmail: (value) => AxiosInterceptor().post(`/emailTemplate/updateTemplate`, value),
    deleteEmail: (value) => AxiosInterceptor().post(`/deleteTemplate`, value),
    changeStatusEmail: (value) => AxiosInterceptor().post("/emailTemplate/changeStatus", value),
};

export const apiCategory = {
    add: (value) => AxiosInterceptor().post(`/category/category`, value),
    edit: (value) => AxiosInterceptor().post(`/category/update-category`, value),
    delete: (value) => AxiosInterceptor().post(`/category/delete-category`, value),
    getAll: (values) => AxiosInterceptor().post(`/category/categories`, values),
    getById: (values) => AxiosInterceptor().post(`/category/single-category`, values),
    changeStatus: (value) => AxiosInterceptor().post("/category/update-status", value),
    getAllSubCategory: (values) => AxiosInterceptor().post(`/subcategory/getAllSubcategories`, values),
    addSubCategory: (value) => AxiosInterceptor().post(`/subcategory/add-subcategory`, value),
    editSubCategory: (value) => AxiosInterceptor().post(`/subcategory/edit-subcategory`, value),
    deleteSubCategory: (value) => AxiosInterceptor().post(`/subcategory/delete-subcategory`, value),
    getByIdSubCategory: (values) => AxiosInterceptor().post(`/subcategory/get-by-id`, values),
    changeStatusSubCategory: (value) => AxiosInterceptor().post("/subcategory/update-status", value),
};

export const apiCms = {
    add: (value) => AxiosInterceptor().post(`/cms/addContent`, value),
    edit: (value) => AxiosInterceptor().post(`/cms/updateContent`, value),
    delete: (value) => AxiosInterceptor().post(`/delete`, value),
    getAll: (values) => AxiosInterceptor().post(`/cms/getAllContent`, values),
    getById: (values) => AxiosInterceptor().get(`/cms/getOneContent/${values.id}`, values),
    changeStatus: (value) => AxiosInterceptor().post("/update-status", value),

    // Faq
    getFaq: (values) => AxiosInterceptor().post(`/faq/getAllFaqs`, values),
    addFaq: (value) => AxiosInterceptor().post(`/faq/addfaq`, value),
    getByIdFaq: (values) => AxiosInterceptor().get(`/faq/getOneFaq/${values.id}`),
    editFaq: (value) => AxiosInterceptor().post(`/faq/updateFaq`, value),
    deleteFaq: (value) => AxiosInterceptor().post(`/faq/deleteFaq`, value),
    changeStatusFaq: (value) => AxiosInterceptor().post("/faq/changeStatus", value),
};

export const aboutUsService = {
    getById: (values) => AxiosInterceptor().get(`/cms/getAboutUsDetails/${values?.id}`),
    getOptions: (values) => AxiosInterceptor().post(`/cms/getAllModels`, values),
    updateAboutUs: (values) => AxiosInterceptor().post(`/cms/updateAboutUs`, values),
};